"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiOrderDto = exports.BillingApiOrderAbstractDto = void 0;
const billing_api_charge_dto_1 = require("../../../billing-api-charge/types/dtos/billing-api-charge.dto");
const swagger_1 = require("../../../../swagger-fake");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const billing_api_order_contractor_dto_1 = require("./billing-api-order-contractor.dto");
const key_value_1 = require("../../../../shared/types/key-value");
let BillingApiOrderAbstractDto = class BillingApiOrderAbstractDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Валюта счёта",
  format: "^[A-Z]{3}$",
  example: "USD"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsString)(), (0, class_validator_1.Length)(3, 3), __metadata("design:type", String)], BillingApiOrderAbstractDto.prototype, "currencyCode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Комиссия овнера в процентах (может быть с дробной частью)`,
  format: "decimal",
  example: "50.5"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsDecimal)({
  decimal_digits: "1,"
}), __metadata("design:type", String)], BillingApiOrderAbstractDto.prototype, "ownerFee", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Произвольное текстовое описание (может использоваться в истории). Можно использовать
    i18n ключ совместимый с системой-клиентом биллинга.`,
  type: String,
  nullable: true,
  required: false
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsString)(), __metadata("design:type", Object)], BillingApiOrderAbstractDto.prototype, "description", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Кратковременная сделка (автоматически закрывается после оплаты первого начисления)",
  type: Boolean,
  default: false,
  required: false
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsBoolean)(), __metadata("design:type", Object)], BillingApiOrderAbstractDto.prototype, "isOneTime", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Сделка в тестовом режиме (без реальных оплат и выплат)",
  type: Boolean,
  default: false,
  required: false
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsBoolean)(), __metadata("design:type", Object)], BillingApiOrderAbstractDto.prototype, "isTestMode", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Произвольные мета-данные для внешнего сервиса-клиента биллинга.
    Используется для поиска, сопоставления с приобретаемым товаром/услугой,
    обогащения данными при выводе пользователю и т.д.
    Свойство обязательно и должно содержать минимум одну пару key=value для избежания 
    "неопознанных" сделок.`,
  type: () => key_value_1.Metadata,
  example: {
    meetingId: ""
  }
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsObject)(), __metadata("design:type", key_value_1.Metadata)], BillingApiOrderAbstractDto.prototype, "meta", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Версия мета-данных`,
  pattern: "int"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsNumber)(), (0, class_validator_1.IsPositive)(), __metadata("design:type", Number)], BillingApiOrderAbstractDto.prototype, "metaVersion", void 0);
BillingApiOrderAbstractDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiOrderAbstractDto);
exports.BillingApiOrderAbstractDto = BillingApiOrderAbstractDto;
let BillingApiOrderDto = class BillingApiOrderDto extends BillingApiOrderAbstractDto {};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Контрагенты сделки: 1 поставщик (не обязательно), 1 покупатель; N-комиссионеров (не обязательно)",
  type: () => billing_api_order_contractor_dto_1.BillingApiOrderContractorDto,
  isArray: true,
  minItems: 1
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsArray)(), (0, class_validator_1.ArrayMinSize)(1), (0, class_validator_1.ValidateNested)({
  each: true
}), (0, class_transformer_1.Type)(() => billing_api_order_contractor_dto_1.BillingApiOrderContractorDto), __metadata("design:type", Array)], BillingApiOrderDto.prototype, "contractors", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: `Одно или несколько начислений на оплату за предоставляемые товары или услуги (не обязательно,
    так как начисления можно добавить в любой момент пока сделка не звершена или не отменена, но удобно создать сразу
    осбенно для кратковременных сделок с одним начислением).`,
  type: () => billing_api_charge_dto_1.BillingApiChargeDto,
  nullable: true,
  required: false,
  isArray: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsArray)(), (0, class_validator_1.ValidateNested)({
  each: true
}), (0, class_transformer_1.Type)(() => billing_api_charge_dto_1.BillingApiChargeDto), __metadata("design:type", Object)], BillingApiOrderDto.prototype, "charges", void 0);
BillingApiOrderDto = __decorate([(0, class_transformer_1.Exclude)()], BillingApiOrderDto);
exports.BillingApiOrderDto = BillingApiOrderDto;
